<template lang="pug">
  #plan
    header.planPost__header
      button.planPost__back(@click="$router.push('/')")
        fa(icon="home")
        span &nbsp; Home
      router-link.title.is-4(to="/itc/instructionalplans" style="margin: 0; padding: 0; font-weight: lighter; font-size: 1.5rem; text-transform: uppercase")
        i(style="color: #049FD9") Training Instructional Plans
      span(style="display: inline-block; width: 8rem")
    div.plan__description(style="margin-left: auto; margin-right:auto;")
      span Sharpen the saw with us! CNAP Core Council of the Philippines – Instructor Training Center is committed to provide you with the right tools and programs to advance your careers under the Cisco Network Academy Program. Simply click on the link of the courses you are interested in to view the training instructional plan that lists the course description, pre-requisites, learning outcomes, deliverables, method of instruction, schedule, and outline.
  
    div.plans
      layout-container(style="max-width: 900px")
        router-link.plan(v-for="post, index in $store.state.itc.itcfeed" :to="'/itc/instructionalplans/' + post.id" :key="post.id")
          div.plan__banner(:style="{backgroundImage: 'url(' + post.cover + ')'}")
          div.plan__contents
            .plan__title(style="color: #049FD9;") {{ post.title }}

</template>

<style lang="sass" scoped>
@import '../assets/style'

#plan
  border-top: 5px solid $color-primary
  background-color: $color-background-light

.planPost__header
  max-width: 900px
  margin-left: auto
  padding: $pad 0
  margin-right: auto
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  border-bottom: 1px solid #dddddd

.planPost__title
  padding: $pad*2 $pad
  max-width: 900px
  margin-left: auto
  margin-right: auto
  font-weight: lighter

.plan__title
  font-weight: lighter
  margin-bottom: 1.5rem
  font-size: 18pt

.planNav
  display: flex
  align-items: center
  justify-content: space-between
  height: 4rem
  

.planNav__action
  padding: 1rem
  @include actionable-primary
  display: flex
  align-items: center
  justify-content: center
  border-radius: 3rem
  height: 3rem
  margin: 0.5rem
  text-decoration: none
  color: inherit

.planNav__action--small
  width: 3rem

.plans
  margin-top: $pad*2

.plan
  border-radius: 0.5rem
  background-color: $color-background-light
  margin: $pad 0
  border: 1px solid $color-layout-border
  overflow: hidden
  display: grid
  grid-template-columns: 1fr
  cursor: pointer
  text-decoration: none
  color: inherit
  border-right: 5px solid #049FD9
  &:hover
    background-color: rgba(0,0,0,0.025)

  @include from($tablet-portrait)
    grid-template-columns: 1fr 1fr



.plan__banner
  width: 100%
  background-color: #ddd
  background-size: contain;
  background-position: center

  height: 60vw
  @include from($tablet-portrait)
    height: 100%

.plan__contents
  padding: $pad*2
  
.planPost__back
  background-color: transparent

.plan__description
  max-width: 900px 
  color: $color-primary
  padding: 15px
  border-radius: 7px
  font-weight: normal
  text-shadow: 0px 1px gray
</style>



<script>
import layoutContainer from '@/components/layoutContainer'

export default {
  name: 'Module',
  components: {
    layoutContainer
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch('loadITC');
  }
}
</script>